import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-32 text-center">
      <XCircle size={48} className="mx-auto text-gray-400" />
      <h1 className="font-heading text-3xl font-extrabold mt-6">Paiement annulé</h1>
      <p className="text-gray-500 mt-3">Votre panier a été conservé. Vous pouvez réessayer quand vous le souhaitez.</p>
      <Link to="/panier" className="inline-block mt-8 bg-brand-red text-white px-8 py-4 font-semibold">Retour au panier</Link>
    </div>
  );
}
